import React, { Component } from "react";
import * as Server from "../Server";
import {
  Card,
  CardBody,
  CardHeader,
  Label,
  Input,
  Row,
  Col,
  Button,
  Table,
  Form,
  Modal,
  FormGroup,
  ModalBody,
  ModalFooter,
  ModalHeader,
} from "reactstrap";
import { MdKeyboardArrowLeft, MdKeyboardArrowRight } from "react-icons/md";
import Page from "../components/Page";
import PageSpinner from "../components/PageSpinner";
import * as GeneralFunctions from "../GeneralFunctions";
import NotificationSystem from "react-notification-system";
import { NOTIFICATION_SYSTEM_STYLE } from "../utils/constants";
import { GlobalContext } from "../components/Layout/MainLayout";

class RushStaff extends Component {
  constructor(props) {
    super(props);
    this.state = {
      page: 1,
      pages: 0,
      limit: 10,
      globalSearchData: "",
      Teams: [],
      staff: {},
      rushUsers: [],
      totalUsers: 0,
      pageNumbers: [],
      teamModel: false,
      addStaffModel: false,
      registerFormFieldsStaff: [],
    };
  }
  componentDidMount() {
    this.setState({ limit: this.context.limit }, () => this.getStaff());
    this.getRegistrationForm();
  }

  getRegistrationForm = async () => {
    let user = GeneralFunctions.getAuthUser();
    try {
      this.setState({ showLoader: true });
      let response = await Server.request({
        url: `rushsoccer/registration/form?clubId=${user.connectUserId}`,
        method: "GET",
      });
      if (
        response.registrationFormDetails &&
        response.registrationFormDetails.registerForm
      ) {
        let allFields = response.registrationFormDetails.registerForm.reduce(
          (previousValue, currentValue) => {
            previousValue.push(...currentValue.fields);
            return previousValue;
          },
          []
        );
        let Fields = allFields.filter(
          (form) =>
            form.for.value === "staff" &&
            form.default === true &&
            form.inputType !== "fileupload"
        );
        this.setState({
          showLoader: false,
          registerFormFieldsStaff: Fields,
        });
      }
    } catch (error) {
      this.setState({ showLoader: false });
      this.notificationSystem.addNotification({
        message: error.message,
        level: "error",
      });
    }
  };

  getStaff = async (event) => {
    if (event) event.preventDefault();
    let user = GeneralFunctions.getAuthUser();
    try {
      this.setState({ showLoader: true });
      let page = this.state.page;
      let pageLimit = this.state.limit;
      let response = await Server.serverRequest({
        url: "rushUser/web/getUsers",
        method: "POST",
        data: {
          page,
          pageLimit,
          type: "staff",
          clubId: user.connectUserId,
          globalSearchData: this.state.globalSearchData || "",
        },
      });
      if (response) {
        this.setState({
          showLoader: false,
          rushUsers: response.rushUsers,
          totalUsers: response.totalUsers,
          pages: response.pages,
        });
        let pageNumbers = [];
        for (let page = 1; page <= response.pages; page++) {
          pageNumbers.push(page);
        }
        this.setState({ pageNumbers: pageNumbers });
      }
    } catch (error) {
      this.setState({ showLoader: false });
      this.notificationSystem.addNotification({
        message: error.message,
        level: "error",
      });
    }
  };

  createStaff = async (event) => {
    if (event) event.preventDefault();
    let user = GeneralFunctions.getAuthUser();
    try {
      this.setState({ showLoader: true });
      let response = await Server.serverRequest({
        url: "rushUser/registerStaff",
        method: "POST",
        data: {
          data: this.state.staff,
          clubId: user.connectUserId,
        },
      });
      if (response) {
        this.setState({ showLoader: false, staff: {} });
        this.notificationSystem.addNotification({
          message: response.message,
          level: "success",
        });
        this.getStaff();
        this.toggleAddStaffModel();
      }
    } catch (error) {
      this.setState({ showLoader: false });
      this.notificationSystem.addNotification({
        message: error.message,
        level: "error",
      });
    }
  };

  refreshPagination = (page, limit) => {
    this.setState({ page: parseInt(page, 10), limit: limit }, () => {
      this.getStaff();
    });
  };

  toggleTeamModel = (event) => {
    event.preventDefault();
    this.setState({
      teamModel: !this.state.teamModel,
    });
  };

  toggleAddStaffModel = (event) => {
    if (event) event.preventDefault();
    this.setState({
      addStaffModel: !this.state.addStaffModel,
      staff: {},
    });
  };

  render() {
    return (
      <div>
        <PageSpinner showLoader={this.state.showLoader} />
        <Page title="Staff" breadcrumbs={[{ name: "Staff", active: true }]}>
          <Card>
            <CardHeader>
              <Row>
                <Col xl={4} lg={12} md={12}>
                  <div className="d-flex">
                    <div sm={4} className="mt-2 pr-2">
                      <Label>Shown</Label>
                    </div>
                    <div sm={4}>
                      <Input
                        type="select"
                        name="pageLimit"
                        value={this.state.limit}
                        onChange={(event) => {
                          this.refreshPagination(1, event.target.value);
                          this.context.updateState({
                            limit: event.target.value,
                          });
                        }}
                      >
                        <option value={10}>10</option>
                        <option value={50}>50</option>
                        <option value={100}>100</option>
                      </Input>
                    </div>
                    <div sm={4} className="mt-2 pl-2">
                      <Label>entries</Label>
                    </div>
                  </div>
                </Col>
                <Col xl={4} lg={12} md={12}>
                  <div className="d-flex justify-content-center">
                    <div className="mt-2 pr-2">
                      <Label>
                        Showing{" "}
                        {!this.state.totalUsers
                          ? 0
                          : this.state.page * this.state.limit -
                            (this.state.limit - 1) +
                            " "}{" "}
                        to{" "}
                        {this.state.page * this.state.limit >
                        this.state.totalUsers
                          ? this.state.totalUsers
                          : this.state.page * this.state.limit}{" "}
                        of {this.state.totalUsers}
                      </Label>
                    </div>
                  </div>
                </Col>
                <Col xl={4} lg={12} md={12}>
                  <div className="d-flex justify-content-end">
                    <div sm={4} className="pr-2">
                      <Button
                        className="rounded-circle"
                        disabled={this.state.page <= 1}
                        onClick={(event) =>
                          this.refreshPagination(
                            this.state.page - 1,
                            this.state.limit
                          )
                        }
                      >
                        <MdKeyboardArrowLeft size="20px"></MdKeyboardArrowLeft>
                      </Button>
                    </div>
                    <div sm={4}>
                      <Input
                        type="select"
                        value={this.state.page}
                        name="filter"
                        onChange={(event) => {
                          this.refreshPagination(
                            event.target.value,
                            this.state.limit
                          );
                        }}
                      >
                        {this.state.pageNumbers.length !== 0 ? (
                          this.state.pageNumbers.map((pageNumber, index) => (
                            <option value={pageNumber} key={index}>
                              {pageNumber}
                            </option>
                          ))
                        ) : (
                          <option value={0}>0</option>
                        )}
                      </Input>
                    </div>
                    <div sm={4} className="pl-2">
                      <Button
                        className="rounded-circle"
                        disabled={this.state.page >= this.state.pages}
                        onClick={(event) =>
                          this.refreshPagination(
                            this.state.page + 1,
                            this.state.limit
                          )
                        }
                      >
                        <MdKeyboardArrowRight size="20px"></MdKeyboardArrowRight>
                      </Button>
                    </div>
                  </div>
                </Col>
              </Row>
            </CardHeader>
            <CardBody>
              <Form onSubmit={(e) => this.getStaff(e)}>
                <Row className="mb-3">
                  <Col md={4}>
                    <Input
                      type="search"
                      value={this.state.globalSearchData}
                      placeholder="Search"
                      onChange={(event) =>
                        this.setState({ globalSearchData: event.target.value })
                      }
                    />
                  </Col>
                  <Col md={4}>
                    <Button className="mt-3 mt-md-0">Search</Button>
                  </Col>
                  <Col>
                    <Button
                      className="float-right mr-5"
                      onClick={(event) => this.toggleAddStaffModel(event)}
                    >
                      Add Staff
                    </Button>
                  </Col>
                </Row>
              </Form>
              <Row>
                <Col>
                  <Table striped hover responsive>
                    <thead>
                      <tr>
                        <th>First Name</th>
                        <th>Last Name</th>
                        <th>Email</th>
                        <th>Phone</th>
                        <th>Teams</th>
                      </tr>
                    </thead>
                    <tbody>
                      {this.state.rushUsers.length > 0 ? (
                        this.state.rushUsers.map((user, index) => (
                          <tr key={index}>
                            <td>
                              {GeneralFunctions.capitalizeFirstLetter(
                                user.data.firstName || ""
                              )}
                            </td>
                            <td>
                              {GeneralFunctions.capitalizeFirstLetter(
                                user.data.lastName || ""
                              )}
                            </td>
                            <td>{user.data.email}</td>
                            <td>{user.data.phone}</td>
                            <td
                              style={{ cursor: "pointer", color: "blue" }}
                              onClick={(event) => {
                                this.setState({ Teams: user.teams }, () =>
                                  this.toggleTeamModel(event)
                                );
                              }}
                            >
                              {user.totalTeams}
                            </td>
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td colSpan="5" className="text-center">
                            No Staff found
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </Table>
                </Col>
              </Row>
            </CardBody>
            {this.state.teamModel ? (
              <Modal
                isOpen={this.state.teamModel}
                toggle={(event) => this.toggleTeamModel(event)}
                className="modal-md"
              >
                <ModalHeader toggle={(event) => this.toggleTeamModel(event)}>
                  <Label>All Teams</Label>
                </ModalHeader>
                <ModalBody>
                  <div className="d-flex flex-wrap ">
                    {this.state.Teams && this.state.Teams.length > 0 ? (
                      this.state.Teams.map((team, index) => (
                        <Card
                          key={index}
                          className="d-flex justify-content-center mr-2 mb-2"
                        >
                          <Label className="m-2 text-center">{team.name}</Label>
                        </Card>
                      ))
                    ) : (
                      <Label>No teams found</Label>
                    )}
                  </div>
                </ModalBody>
                <ModalFooter>
                  <Button
                    color="secondary"
                    onClick={(event) => this.toggleTeamModel(event)}
                  >
                    Close
                  </Button>
                </ModalFooter>
              </Modal>
            ) : null}
            {this.state.addStaffModel ? (
              <Modal
                isOpen={this.state.addStaffModel}
                toggle={(event) => this.toggleAddStaffModel(event)}
                className="modal-md"
              >
                <Form
                  className="form"
                  onSubmit={(event) => this.createStaff(event)}
                >
                  <ModalHeader
                    toggle={(event) => this.toggleAddStaffModel(event)}
                  >
                    <Label className="h3 ml-3">
                      <b>Add Staff</b>
                    </Label>
                  </ModalHeader>
                  <ModalBody>
                    <Card>
                      <CardBody>
                        {this.state.registerFormFieldsStaff.length > 0 &&
                          this.state.registerFormFieldsStaff.map(
                            (field, index) => (
                              <Row key={index}>
                                <Col xs={12}>
                                  <FormGroup>
                                    <Label for={field.name}>
                                      {field.placeholder}
                                    </Label>
                                    <Input
                                      type={field.inputType}
                                      required={field.required}
                                      name={field.name}
                                      placeholder={field.placeholder}
                                      value={
                                        this.state.staff[field.keyName] || ""
                                      }
                                      onChange={(event) => {
                                        event.persist();
                                        this.setState((prevState) => ({
                                          staff: {
                                            ...prevState.staff,
                                            [field.keyName]: event.target.value,
                                          },
                                        }));
                                      }}
                                    ></Input>
                                  </FormGroup>
                                </Col>
                              </Row>
                            )
                          )}
                      </CardBody>
                    </Card>
                  </ModalBody>
                  <ModalFooter>
                    <div className="d-flex align-items-center justify-content-center ">
                      <Button className="mr-3" type="submit">
                        Add Staff
                      </Button>
                      <Button
                        onClick={(event) => this.toggleAddStaffModel(event)}
                      >
                        Cancel
                      </Button>
                    </div>
                  </ModalFooter>
                </Form>
              </Modal>
            ) : null}
          </Card>
          <NotificationSystem
            dismissible={false}
            ref={(notificationSystem) =>
              (this.notificationSystem = notificationSystem)
            }
            style={NOTIFICATION_SYSTEM_STYLE}
          />
        </Page>
      </div>
    );
  }
}
RushStaff.contextType = GlobalContext;
export default RushStaff;
